import { render, staticRenderFns } from "./action-head-block.vue?vue&type=template&id=b0132bb0&scoped=true"
import script from "./action-head-block.vue?vue&type=script&lang=js"
export * from "./action-head-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0132bb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0132bb0')) {
      api.createRecord('b0132bb0', component.options)
    } else {
      api.reload('b0132bb0', component.options)
    }
    module.hot.accept("./action-head-block.vue?vue&type=template&id=b0132bb0&scoped=true", function () {
      api.rerender('b0132bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-blocks/components/action-head-block.vue"
export default component.exports